import { niceStep } from "../core/PriceScale";
import { formatAxisTime } from "../core/TimeScale";
import { PALETTE } from "../core/Theme";
import type { Frame } from "./Frame";

export function renderGrid(f: Frame) {
  const { ctx, L, tc, opts } = f;
  ctx.strokeStyle = tc.grid;
  ctx.lineWidth = 1;
  ctx.fillStyle = tc.axisText;
  ctx.font = `11px ${PALETTE.mono}`;
  ctx.textBaseline = "middle";
  const range = f.maxP - f.minP || 1;
  const mode = opts.scaleMode || "normal";
  const ref = f.candles[f.candles.length - 1]?.close || 0; // percent mode: change vs the latest close
  if (mode === "percent" && ref > 0) {
    const pctRange = (range / ref) * 100;
    const pstep = niceStep(pctRange, 6);
    const pMin = ((f.minP - ref) / ref) * 100, pMax = ((f.maxP - ref) / ref) * 100;
    for (let pc = Math.ceil(pMin / pstep) * pstep; pc <= pMax; pc += pstep) {
      const y = f.y(ref * (1 + pc / 100));
      ctx.beginPath(); ctx.moveTo(L.plotLeft, y); ctx.lineTo(L.plotRight, y); ctx.stroke();
      ctx.textAlign = "left";
      ctx.fillText(`${pc > 0 ? "+" : ""}${pc.toFixed(pstep < 0.1 ? 2 : 1)}%`, L.plotRight + 6, y);
    }
  } else {
    // log mode: labels stay in price units but are placed through the (log) transform, spaced by pixels so they never overlap
    const ticks = mode === "log" ? 6 : 6;
    const step = niceStep(range, ticks);
    const first = Math.ceil(f.minP / step) * step;
    let lastY = -Infinity;
    for (let pr = first; pr <= f.maxP; pr += step) {
      const y = f.y(pr);
      if (Math.abs(y - lastY) < 14) continue;
      lastY = y;
      ctx.beginPath(); ctx.moveTo(L.plotLeft, y); ctx.lineTo(L.plotRight, y); ctx.stroke();
      ctx.textAlign = "left";
      ctx.fillText(pr.toFixed(opts.decimals), L.plotRight + 6, y);
    }
  }
  const labelCount = Math.max(2, Math.floor(L.plotW / 90)); // ≥ 90px per label so narrow (mobile) plots never overlap
  const tStep = Math.max(1, Math.ceil(f.count / labelCount));
  ctx.textAlign = "center";
  ctx.textBaseline = "top";
  const last = Math.ceil(f.endFrac);
  for (let i = f.start; i <= last; i += tStep) {
    const c = f.candles[i];
    if (i < 0) continue;
    const x = f.x(i);
    ctx.strokeStyle = tc.grid;
    ctx.beginPath(); ctx.moveTo(x, L.plotTop); ctx.lineTo(x, L.h - L.bottomAxis); ctx.stroke();
    ctx.fillStyle = tc.axisText;
    ctx.globalAlpha = c ? 1 : 0.55; // future space: extrapolated time labels, no data
    ctx.fillText(formatAxisTime(c ? c.time : f.timeAt(x), opts.tfSeconds), x, L.h - L.bottomAxis + 6);
    ctx.globalAlpha = 1;
  }
}
